import React from 'react';
import { updateCredential } from 'js/actions';
import ResourceDetailHeader from 'js/components/ResourceDetailHeader/ResourceDetailHeader';
import { RESOURCE_TYPE_CREDENTIALS } from 'js/constants/resourceTypes';
import { Button } from 'new/elements/Button';
import CredentialDetailActionsContainer from 'js/components/credentials/cards/CredentialDetailActionsContainer';
import LightningStatus from 'new/elements/LightningStatus';
import { Stack } from 'new/elements/Stack';
import styles from './CredentialsDetailHeader.module.scss';
import { ChipWithCopy } from 'new/elements/ChipWithCopy';
import { useIsLoading } from 'new/hooks/adapters/useIsLoading';
import { PROBE_CREDENTIAL_REQUEST } from 'js/constants/actionTypes';
import useAppDispatch from 'js/hooks/useAppDispatch';
import { PrimarySpinner } from 'new/components/icons/PrimarySpinner/PrimarySpinner';
import { ReactComponent as RefreshIcon } from 'new/components/icons/fi-rr-refresh-no-border.svg';

interface CredentialsDetailHeaderProps {
  readOnly: boolean;
  adminAccess: boolean;
  disableEditing: boolean;
  data: any;
  status: any;
  hideActions: boolean;
  isEditable: any;
  isDetected: boolean;
  disableEditMessage: any;
  isManaged: any;
  connectionOrVendorType: any;
  statsContentView: any;
  onCloseDrawer?(): void;
}

const Connection = ResourceDetailHeader.TopContent.Connection;

export const CredentialsDetailHeader = (props: CredentialsDetailHeaderProps) => {
  const {
    readOnly,
    adminAccess,
    hideActions,
    status,
    data,
    disableEditing,
    disableEditMessage,
    statsContentView,
  } = props;
  const dispatch = useAppDispatch();
  const isLoading = useIsLoading(PROBE_CREDENTIAL_REQUEST);
  const credentialStatus = status || data?.validStatus;

  const updateInfo = (id, info) => {
    const payload = {
      cred_name: info.name,
      cred_desc: info.description,
    };
    dispatch(updateCredential(data.id, payload));
  };

  return (
    <ResourceDetailHeader
      readOnly={readOnly}
      adminAccess={adminAccess}
      data={data}
      onCloseDrawer={props?.onCloseDrawer}
      updateInfo={updateInfo}
    >
      <ResourceDetailHeader.TopContent>
        <Stack direction="row" alignItems="center" justifyContent="space-between" gap="16px">
          <Stack direction="row" alignItems="center" gap="16px">
            <Connection resourceType={RESOURCE_TYPE_CREDENTIALS} data={data} />
            <ChipWithCopy tooltipTitle="Copy Credential ID" toCopy={data.id}>
              ID {data.id}
            </ChipWithCopy>
            <div className={styles.boxInfo}>
              <LightningStatus status={credentialStatus} />
            </div>
          </Stack>
          {!hideActions && (
            <Stack direction="row" alignItems="center" gap="16px">
              <CredentialDetailActionsContainer
                data={data}
                readOnly={readOnly}
                disableEditing={disableEditing}
                disableEditMessage={disableEditMessage}
                hideMenuDetails={true}
                ButtonComponent={
                  <Button
                    variant="outlined"
                    color="primary"
                    style={{ backgroundColor: 'white' }}
                    startIcon={
                      isLoading ? (
                        <PrimarySpinner />
                      ) : (
                        <RefreshIcon style={{ color: 'transparent' }} className={styles.testIcon} />
                      )
                    }
                  >
                    Test Connection
                  </Button>
                }
              />
            </Stack>
          )}
        </Stack>
      </ResourceDetailHeader.TopContent>
      {statsContentView}
    </ResourceDetailHeader>
  );
};
